import { useEffect } from "react";
import { DesignRequestFormFields as BaseDesignRequestFormFields } from "./DesignRequestFormV4_4";
import { INTAKE_FORM_VERSION } from "../version";
import "./DesignRequestFormVersion4.css";

export * from "./DesignRequestFormV4_4";
export const FORM_VERSION = INTAKE_FORM_VERSION;

export const DesignRequestFormFields = (props) => {
  useEffect(() => {
    if (!props.setSkuItems) return;
    props.setSkuItems((previous) => {
      let changed = false;
      const next = (previous || []).map((sku) => {
        if (String(sku?.symbol || "").trim()) return sku;
        changed = true;
        return { ...sku, symbol: "None" };
      });
      return changed ? next : previous;
    });
  }, [props.setSkuItems]);

  return <BaseDesignRequestFormFields {...props} />;
};
